import { FormControl, FormLabel, Select, Box, Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import {
  AdminBookingUpdateProps,
  RequestProps,
  StudentModelProps,
} from "../../types";
import AddStudentDetails from "./AddStudentDetails";
import StudentsLists from "./StudentsLists";
import UpdateStudentDetails from "./UpdateStudentDetails";
import { getClasses } from "../../data";

const RequestModalContent = ({
  requests,
  students,
  setSelectedRequestId,
  selectedRequestId,
  updateStudentDetails,
  refreshRequests,
}: {
  requests: RequestProps[];
  students: StudentModelProps[];
  setSelectedRequestId: React.Dispatch<React.SetStateAction<number>>;
  selectedRequestId: number;
  updateStudentDetails: AdminBookingUpdateProps["updateStudentDetails"];
  refreshRequests: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [openFormDrawer, setOpenFormDrawer] = useState<{
    type: "add" | "update";
    triggered: boolean;
  }>({ type: "add", triggered: false });
  const [clickedStudentIndex, setClickedStudentIndex] = useState(0);
  const [updatingStudentId, setUpdatingStudentId] = useState(0);
  const [classes, setClasses] = useState<string[]>([]);
  const [classesError, setClassesError] = useState(false);
  const request = requests.find(
    (request: RequestProps) => selectedRequestId === request.id
  );

  useEffect(() => {
    // reset the clicked index when drawer is closed
    if (!openFormDrawer.triggered) {
      setClickedStudentIndex(0);
    }
  }, [openFormDrawer.triggered]);

  const setToggleForm = (type: "add" | "update", triggered: boolean) => {
    setOpenFormDrawer({ type, triggered });
  };

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const classes = await getClasses();
        mounted && setClasses(classes);
      } catch (e) {
        mounted && setClassesError(true);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      {request && (
        <>
          <AddStudentDetails
            setToggleDrawer={setToggleForm}
            toggleDrawer={openFormDrawer.triggered}
            request={request}
            clickedStudentIndex={clickedStudentIndex}
            addDetailsFn={updateStudentDetails}
            classes={classes}
            students={students}
            refreshRequests={refreshRequests}
          />
          <UpdateStudentDetails
            studentIndex={clickedStudentIndex}
            setToggleDrawer={setToggleForm}
            toggleDrawer={openFormDrawer.triggered}
            updatingStudent={students.find(
              (student) => student.id === updatingStudentId
            )}
            classExpectation={
              request.students.find(
                (student) => student.id === updatingStudentId
              )?.expectation
            }
            request={request}
            updateDetailsFn={updateStudentDetails}
            classes={classes}
            refreshRequests={refreshRequests}
          />
        </>
      )}
      <FormControl mb="2rem">
        <FormLabel htmlFor="requests">Select request to link</FormLabel>
        <Select
          onChange={(e) => setSelectedRequestId(+e.target.value.toLowerCase())}
          value={selectedRequestId}
        >
          <option value="">None</option>
          {requests.map((request) => (
            <option key={request.id} value={request.id}>
              {request.slug} - {request.date}
            </option>
          ))}
        </Select>
      </FormControl>
      <Box mt="2rem">
        {request?.id && (
          <StudentsLists
            requestStudents={request.students}
            setToggleForm={setToggleForm}
            students={students}
            setClickedStudentIndex={setClickedStudentIndex}
            setUpdatingStudentId={setUpdatingStudentId}
          />
        )}
      </Box>
      {classesError && (
        <Text color={"tomato"} mt="1rem">
          Failed to fetch classes
        </Text>
      )}
    </>
  );
};

export default RequestModalContent;
